import http from '@/core/http';
// import { DOMAIN_SYSTEM_ENUM } from '@/core/http/type';
import { DOMAIN_SYSTEM_ENUM } from '@toy/utils';
import {
  UserReq,
  UserRes,
  IUsersQueryUserReq,
  IUsersQueryUserRes,
} from './index.d';
import { useAccountStore } from '@/store/account/index';

// // 根据关键字检索用户
// export const fuzzyQueryUser_old = (params: { keyword: string; }) => {
//   const url = `/authManage/user/${params.keyword}`;
//   return http.get<{ users: UserItem[]; }>({
//     server: DOMAIN_SYSTEM_ENUM.baibu, // 测试
//     url,
//   });
// };

const accountStore = useAccountStore();
// SSO-根据关键字检索用户(根据用户名和公司ID查询用户的编码、ID和username)
export const fuzzyQueryUser = (data: UserReq & { keyword?: string; }) => {
  const url = '/sso-center/admin/users/query-user-by-username-and-companyId';
  data.username = data.keyword || '';
  data.companyId = accountStore.currentCompany?.companyId || '';
  delete data.keyword;
  return http.post<UserRes>({
    url,
    data,
    server: DOMAIN_SYSTEM_ENUM.ARSENAL_API,
  });
};

// 查用户的手机号码，另外调sso接口
// https://yapi.ibaibu.com/project/1656/interface/api/97892
export const queryUserMobile = (data: IUsersQueryUserReq) => {
  data.companyId = accountStore.currentCompany?.companyId || '';
  const url = '/sso-center/admin/users/query-user';
  return http.post<IUsersQueryUserRes>({
    url,
    data,
    server: DOMAIN_SYSTEM_ENUM.ARSENAL_API,
  });
};
